export default {
  more: 'もっと見る',
  retract: '見ない',
}
